"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative flex h-screen w-full items-center overflow-hidden bg-primary">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515527/img/hero_background_children_care.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-primary/70" aria-hidden="true" />

      {}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-8 lg:px-12">
        <h1 className={`max-w-4xl text-left font-display text-5xl font-bold leading-tight text-white transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] md:text-6xl lg:text-7xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>Thrive — Nurturing Children’s Futures</h1>
      </div>
    </section>;
}